import React from 'react';
import PropTypes from 'prop-types';
import { ComponentLoader } from './ComponentLoader/ComponentLoader';

/**
 * PromoCode Component Loader (dibs-display-promo-code)
 */
const importFunc = () => {
    return import(/* webpackChunkName: "PromoCode" */
    'dibs-display-promo-code').then(esExport => esExport.default);
};

export function PromoCodeLoader(props) {
    return (
        <ComponentLoader
            {...props}
            load={props.load}
            importFunc={importFunc}
            useLoadingComponent={false}
        />
    );
}

PromoCodeLoader.propTypes = {
    load: PropTypes.bool.isRequired,
};
